import { createTimeoutSignal } from './timeout-signal.js';

/** The handoff never reads or mints a general account JWT. */
export function plusBillingRequest(billingUrl, binding, csrfToken, checkAccount, expire) {
    return async (endpoint, options = {}) => {
        const match = /^\/(plus-plan-change|plus-payment|plus-refund-request|plus-billing-history)(?:\?before_id=([1-9][0-9]*))?$/.exec(endpoint);
        const method = options.method || 'GET';
        if (!match || !['GET', 'POST'].includes(method) || (['plus-payment', 'plus-billing-history'].includes(match[1]) && method !== 'GET')) {
            throw new Error('Unsupported billing request');
        }
        if (!checkAccount()) throw new Error('Billing context expired');
        const query = new URLSearchParams({ resource: match[1] });
        if (match[2]) query.set('before_id', match[2]);
        const timeout = createTimeoutSignal(15000);
        try {
            const response = await fetch(`${billingUrl}?${query}`, {
                method,
                credentials: 'same-origin',
                cache: 'no-store',
                signal: timeout.signal,
                headers: {
                    'Content-Type': 'application/json',
                    'X-Plus-Billing-Binding': binding,
                },
                ...(method === 'POST' ? { body: JSON.stringify({ ...JSON.parse(options.body), csrf_token: csrfToken }) } : {}),
            });
            if (response.redirected || response.status === 401) {
                expire();
                throw new Error('Billing context expired');
            }
            const data = await response.json();
            if (!checkAccount()) throw new Error('Billing context expired');
            if (!response.ok) {
                const error = new Error('Billing request failed');
                error.status = response.status;
                error.code = data?.error?.code;
                error.displayMessage = typeof data?.error?.message === 'string' ? data.error.message : '';
                throw error;
            }
            if (response.headers.get('X-Plus-Billing-Binding') !== binding) {
                expire();
                throw new Error('Billing context changed');
            }
            return data;
        } finally {
            timeout.clear();
        }
    };
}
